module.exports = __webpack_public_path__ + "media/images/front/icon_db-keisai-48251e4c778dbf1e40aecf5d2d530e1d.png";